import React from 'react';
import IndustriesPageLayout from '../components/IndustriesPage/IndustriesPageLayout';

const Industries: React.FC = () => <IndustriesPageLayout />;

export default Industries;
